export const API_URL = process.env.REACT_APP_API_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const STARTING_PRICE_HOUSE_CLEANING = process.env.REACT_APP_STARTING_PRICE_HOUSE_CLEANING;
export const STARTING_TIME_HOUSE_CLEANING = process.env.REACT_APP_STARTING_TIME_HOUSE_CLEANING;


export const BASE_PRICE = process.env.REACT_APP_BASE_PRICE;
export const HOURLY_RATE = process.env.REACT_APP_HOURLY_RATE;
export const MOVE_IN_OUT = process.env.REACT_APP_MOVE_IN_OUT;
